import React, { useEffect, useRef, useState } from 'react'

import DataTableList from '../../components/DataTable/DataTableList'
import NoResults from '../../components/Noresults';
import Dropdown from '../../components/Dropdown/Dropdown';
import { useStaticDataStore } from '../../stores/staticData';
import { USER_REPORT_TYPE, USER_STATUS } from '../../constants/common';
import { dateFormat, formattedDate } from '../../utils/formattedDate';

import search from '../../assets/images/search.svg';
import avatar from '../../assets/images/Avatar.png'
import report from '../../assets/images/report.png'

const CloseReport = (props) => {
    const { setEditReport, reportList, setSelectedReport, totalPage, setCurrentPage, currentPage, searchQuery, setSearchQuery, isLoading, setIsLoadingData, isLoadingData, userTypeSelectRef, reasonRef, LazyImage, setFilterReport, filterReport } = props

    const { data: staticData } = useStaticDataStore();
    const statusRef = useRef();

    let reportReason = [];
    if (staticData?.reportForFounders?.length) {
        reportReason = staticData?.reportForFounders;
    }
    const userType = USER_REPORT_TYPE;
    const userStatus = USER_STATUS;

    const [userTypeSelect, setUserTypeSelect] = useState(false)
    const [reasonSelect, setReasonSelect] = useState(false)
    const [statusSelect, setStatusSelect] = useState(false)
    const [columnWidths, setColumnWidths] = useState([]);

    useEffect(() => {
        if (reportList?.length > 0) {
            calculateColumnWidths().then(() => {
                setTimeout(() => {
                    setIsLoadingData(false);
                }, 1000);
            });
        } else {
            setIsLoadingData(false);
        }
    }, [reportList]);

    const calculateColumnWidths = () => {
        return new Promise((resolve) => {
            const tempWidths = reportList?.reduce((acc, row) => {
                Object.keys(row)?.forEach((key) => {
                    const dataValue = row[key]?.toString();
                    const title = row[key];

                    let maxContentLength = 0;

                    if (key === 'reasons') {
                        const categories = row[key];

                        if (categories?.length > 1) {
                            let tempCatLength = 0;

                            for (let i = 0; i < 1; i++) {
                                tempCatLength = tempCatLength + categories[i]?.length;
                            }

                            maxContentLength = Math?.max(tempCatLength, title?.length);

                        } else {
                            if (categories?.length == 0) {
                                maxContentLength = Math?.max(dataValue?.length + 5);
                            } else {
                                maxContentLength = Math?.max(dataValue?.length + 3, title?.length);
                            }
                        }

                    } else {
                        maxContentLength = Math?.max(dataValue?.length, title?.length);
                    }

                    if (!acc[key] || maxContentLength > acc[key]) {
                        acc[key] = maxContentLength;
                    }
                });
                return acc;
            }, {});
            if (tempWidths !== undefined) {
                const widthMap = Object?.keys(tempWidths)?.reduce((acc, key) => {

                    if (key === 'reasons') {
                        reportList?.forEach((row) => {
                            const categoryWidth = tempWidths[key] * 10 + 40;
                            acc[key] = `${categoryWidth}px`;
                        });
                    } else {
                        acc[key] = `${tempWidths[key] * 10 + 40}px`;
                    }
                    return acc;
                }, {});

                setColumnWidths(widthMap);
            }
            resolve();
        });
    };
    const customStyles = {
        headCells: {
            style: {
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '24px',
                color: '#666666'
            },
        },
    };

    const columns = [
        {
            name: 'Report number',
            selector: (row) => row?.id,
            cell: (row) => {
                return <span className="report-name">
                    #{row?.id || 'NO NAME'}
                </span>
            },
            sortable: true,
            minWidth: "160px",
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 500, lineHeight: '20px', letterSpacing: '-0.28px' },
        },
        {
            name: 'Reported',
            selector: (row) => row?.reportedName,
            cell: (row) => {
                return <div className="vc-content vcTable" onClick={() => { setEditReport(true); setSelectedReport(row); }}>
                    <LazyImage
                        src={row?.reportedProfileImg || avatar}
                        alt="Active founder"
                    />
                    <div className="vc-brief">
                        <span className="vc-name">
                            {row?.reportedName || 'NO NAME'}
                        </span>
                    </div>
                </div>
            },
            sortable: true,
            minWidth: columnWidths['reportedName'] && `${parseInt(columnWidths['reportedName']) + 70}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
        },
        {
            name: 'Reported by',
            selector: (row) => row?.reportByName,
            cell: (row) => {
                return <div className="report-content vcTable">
                    <LazyImage
                        src={row?.reportByProfileImg || avatar}
                        alt="Report by user"
                    />
                    <div className="vc-brief">
                        <span className="vc-name">
                            {row?.reportByName || 'NO NAME'}
                        </span>
                    </div>
                </div>
            },
            sortable: true,
            minWidth: columnWidths['reportByName'] && `${parseInt(columnWidths['reportByName']) + 60}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
        },
        {
            name: 'Reason',
            cell: (row) => {
                var reasons = row?.reasons?.slice(0, 1);
                var reasonFull = row?.reasons?.slice(1);
                const getReasonValue = (itemKey) => {
                    const found = reportReason?.find(rsn => rsn?.key === itemKey);
                    return found ? found?.value : itemKey;
                };
                return (<div className='industriesCategory'>
                    <div>
                        {reasons?.map((item, index) => (
                            <span key={index}>{getReasonValue(item)}</span>
                        ))}
                        {row?.reasons?.length > 1 && (
                            <div className="industriesList">
                                <span>+{row?.reasons?.length - 1}</span>
                                <div className="industriesTooltip">
                                    {reasonFull?.map((item, idx) => (
                                        <p key={idx}>{getReasonValue(item)}</p>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>)
            },
            paddingLeft: 0,
            width: columnWidths['reasons'] && `${parseInt(columnWidths['reasons']) + 25}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", width: columnWidths['reasons'] && `${parseInt(columnWidths['reasons']) - 20}px`, lineHeight: '20px' },
        },
        {
            name: 'Date reported',
            selector: (row) => row?.dateOfReported,
            cell: (row) => {
                return <p>{formattedDate(row?.dateOfReported)}</p>
            },
            sortable: true,
            width: columnWidths['dateOfReported'] && `${parseInt(columnWidths['dateOfReported']) - 85}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
        },
        {
            name: 'Date closed',
            selector: (row) => row?.actionDate,
            cell: (row) => {
                return <p>{formattedDate(row?.actionDate)}</p>
            },
            sortable: true,
            width: columnWidths['actionDate'] && `${parseInt(columnWidths['actionDate']) - 85}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
        },
        {
            name: 'Status',
            selector: (row) => row?.status,
            cell: (row) => {
                const getStatusValue = (statusKey) => {
                    const found = userStatus.find(item => item.key === statusKey);
                    return found ? found.value : statusKey;
                };
                return (
                    <div className="industriesCategory">
                        <span className={`${getStatusValue(row?.status)}`}>
                            {getStatusValue(row?.status)}
                        </span>
                    </div>
                );
            },
            sortable: true,
            width: columnWidths['status'] && `${parseInt(columnWidths['status']) + 25}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 500, lineHeight: '20px', letterSpacing: '-0.28px' },
        },
        {
            name: 'Actions',
            cell: (row) => {
                return (
                    <>
                        <div className='table-actions'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" onClick={() => { setEditReport(true); setSelectedReport(row) }}>
                                <path d="M2.15703 13.583C2.19149 13.2729 2.20872 13.1179 2.25564 12.9729C2.29726 12.8444 2.35607 12.722 2.43048 12.6092C2.51434 12.482 2.62466 12.3717 2.8453 12.151L12.75 2.24632C13.5784 1.41789 14.9216 1.41789 15.75 2.24632C16.5784 3.07475 16.5784 4.41789 15.75 5.24632L5.84529 15.151C5.62466 15.3717 5.51434 15.482 5.38717 15.5658C5.27434 15.6402 5.15197 15.6991 5.02338 15.7407C4.87845 15.7876 4.72339 15.8048 4.41328 15.8393L1.875 16.1213L2.15703 13.583Z" stroke="#05171A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                    </>
                )
            },
            justifyContent: 'flex-end',
            allowOverflow: true,
            button: true,
            minWidth: "55px",
            paddingRight: '16px',
            width: '70px',
            style: { textAlign: 'right', minWidth: '70px', paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px" },
        },
    ]

    return (
        <div className='active-reports'>
            <div className='active-report-top'>
                <div className='pagesSearch twoItemWrap'>
                    <div className="pageSearchInput">
                        <input type="text" name="pages_search" className="inputFields" id="pages_search" placeholder={'Search close reports...'} autoComplete="off" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                        <img src={search} alt="Search" />
                    </div>

                    <Dropdown
                        ref={userTypeSelectRef}
                        selectedDropdown={userTypeSelect}
                        setSelectedDropdown={setUserTypeSelect}
                        items={userType}
                        setSelectedValue={(newValue) =>
                            setFilterReport((prev) => ({
                                ...prev,
                                userType: newValue
                            }))
                        }
                        selectedValue={filterReport?.userType ?? []}
                        name={"User type"}
                    />

                    <Dropdown
                        ref={reasonRef}
                        selectedDropdown={reasonSelect}
                        setSelectedDropdown={setReasonSelect}
                        items={reportReason}
                        setSelectedValue={(newValue) =>
                            setFilterReport((prev) => ({
                                ...prev,
                                reasons: newValue
                            }))
                        }
                        selectedValue={filterReport?.reasons ?? []}
                        name={"Reason"}
                    />

                    <Dropdown
                        ref={statusRef}
                        selectedDropdown={statusSelect}
                        setSelectedDropdown={setStatusSelect}
                        items={userStatus}
                        setSelectedValue={(newValue) =>
                            setFilterReport((prev) => ({
                                ...prev,
                                status: newValue
                            }))
                        }
                        selectedValue={filterReport?.status ?? []}
                        name={"Status"}
                    />

                </div>
            </div>
            <div className='table-pagination-wrapper report-table-list'>
                <div
                    className={`pagesTable dataTable-list ${isLoadingData ? 'loading-list' : ''
                        }`}
                >
                    <DataTableList
                        data={reportList}
                        columns={columns}
                        customStyles={customStyles}
                        onChangePage={setCurrentPage}
                        paginationTotalRows={totalPage}
                        currentPage={currentPage}
                        selectableRowsComponent="input"
                        progressPending={isLoading}
                        progressComponent={<div className="loader-container"> <div className="loader"></div> </div>}
                        noDataComponent={<NoResults title='No close reports yet' description="Looks like there aren’t any close reports to show right now. Keep an eye out - we’ll surface anything that needs your attention!" image={report} />}
                    />
                </div>
            </div>
        </div>
    )
}

export default CloseReport
